import React, { useState } from "react";

import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Box from "@material-ui/core/Box";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import TextField from "@material-ui/core/TextField";
import Divider from "@material-ui/core/Divider";
import Link from "@material-ui/core/Link";
import Grow from "@material-ui/core/Grow";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";

import Grid from "@material-ui/core/Grid";

import Popper from "@material-ui/core/Popper";

import CallIcon from "@material-ui/icons/Call";
import TextsmsOutlinedIcon from "@material-ui/icons/TextsmsOutlined";
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";
import DateRangeOutlinedIcon from "@material-ui/icons/DateRangeOutlined";
import MonetizationOnOutlinedIcon from "@material-ui/icons/MonetizationOnOutlined";
import LocationOnOutlinedIcon from "@material-ui/icons/LocationOnOutlined";
import LogoIcon from "@components/Global/Custom/Logo/LogoIcon";

import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import Slide from "@material-ui/core/Slide";
import WebsiteWidgetForm from "./WebsiteWidgetForm";
import WebsiteLocationHours from "./WebsiteLocationHours";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const { SITE_NAME, BRAND_NAME } = process.env;

const WebsiteWidget = () => {
	const classes = useStyles("Website");

	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));

	const widget = true;
	const location = false;
	const phone = true;
	const text = true;
	const email = true;
	const quote = true;
	const book = true;

	const [value, setValue] = React.useState(""); // nav buttons

	//

	const [open, setOpen] = React.useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose2 = () => {
		setOpen(false);
	};

	//

	const [openMenu, setOpenMenu] = React.useState(false);
	const anchorRef = React.useRef(null);

	const handleToggle = () => {
		//setOpenMenu((prevOpen) => !prevOpen);
		setOpenMenu(true);
	};

	const handleClose = (event) => {
		if (anchorRef.current && anchorRef.current.contains(event.target)) {
			return;
		}

		setOpenMenu(false);
	};

	function handleListKeyDown(event) {
		if (event.key === "Tab") {
			event.preventDefault();
			setOpenMenu(false);
		}
	}

	return (
		<>
			{widget && (
				<>
					<BottomNavigation
						value={value}
						onChange={(event, newValue) => {
							setValue(newValue);
						}}
						showLabels
						className={classes.websiteWidget}
						ref={anchorRef}
					>
						{location && (
							<BottomNavigationAction
								label={"Location"}
								value={"location"}
								icon={<LocationOnOutlinedIcon />}
								classes={{
									root: classes.bottomNavigationRoot,
									label: classes.bottomNavigationLabel,
									wrapper: classes.bottomNavigationWrapper,
								}}
								aria-controls={openMenu ? "menu-list-grow" : undefined}
								aria-haspopup="true"
								onClick={handleClickOpen}
							/>
						)}
						{phone && (
							<BottomNavigationAction
								label={"Call"}
								value={"call"}
								icon={<CallIcon />}
								classes={{
									root: classes.bottomNavigationRoot,
									label: classes.bottomNavigationLabel,
									wrapper: classes.bottomNavigationWrapper,
								}}
								aria-controls={openMenu ? "menu-list-grow" : undefined}
								aria-haspopup="true"
								onClick={fullScreen ? handleClickOpen : handleToggle}
							/>
						)}
						{text && (
							<BottomNavigationAction
								label="Text"
								value={"text"}
								icon={<TextsmsOutlinedIcon />}
								classes={{
									root: classes.bottomNavigationRoot,
									label: classes.bottomNavigationLabel,
									wrapper: classes.bottomNavigationWrapper,
								}}
								aria-controls={openMenu ? "menu-list-grow" : undefined}
								aria-haspopup="true"
								onClick={fullScreen ? handleClickOpen : handleToggle}
							/>
						)}
						{email && (
							<BottomNavigationAction
								label="Email"
								value={"email"}
								icon={<EmailOutlinedIcon />}
								classes={{
									root: classes.bottomNavigationRoot,
									label: classes.bottomNavigationLabel,
									wrapper: classes.bottomNavigationWrapper,
								}}
								aria-controls={openMenu ? "menu-list-grow" : undefined}
								aria-haspopup="true"
								onClick={fullScreen ? handleClickOpen : handleToggle}
							/>
						)}
						{quote && (
							<BottomNavigationAction
								label="Quote"
								value={"quote"}
								icon={<MonetizationOnOutlinedIcon />}
								classes={{
									root: classes.bottomNavigationRoot,
									label: classes.bottomNavigationLabel,
									wrapper: classes.bottomNavigationWrapper,
								}}
								aria-controls={openMenu ? "menu-list-grow" : undefined}
								aria-haspopup="true"
								//onClick={fullScreen ? handleClickOpen : handleToggle}
							/>
						)}
						{book && (
							<BottomNavigationAction
								label={"Book"}
								value={"book"}
								icon={<DateRangeOutlinedIcon />}
								classes={{
									root: classes.bottomNavigationRoot,
									label: classes.bottomNavigationLabel,
									wrapper: classes.bottomNavigationWrapper,
								}}
								aria-controls={openMenu ? "menu-list-grow" : undefined}
								aria-haspopup="true"
								//onClick={fullScreen ? handleClickOpen : handleToggle}
							/>
						)}
					</BottomNavigation>

					<Popper
						open={openMenu}
						anchorEl={anchorRef.current}
						role={undefined}
						transition
						disablePortal
						placement={"bottom-end"}
						style={{ zIndex: 1500, paddingBottom: 20 }}
					>
						{({ TransitionProps, placement }) => (
							<Grow
								{...TransitionProps}
								style={{
									transformOrigin:
										placement === "bottom-end" ? "bottom-end" : "bottom-end",
								}}
							>
								<Paper elevation={6} style={{ width: 400, borderRadius: 16 }}>
									<ClickAwayListener //onClickAway={handleClose}
									>
										<div onKeyDown={handleListKeyDown}>
											<Box
												p={5}
												display={"flex"}
												alignItems={"center"}
												justifyContent={"space-between"}
											>
												<Box fontSize={20} fontWeight={600} lineHeight={1}>
													{value === "call" && "Call Me"}
													{value === "text" && "Text With Us"}
													{value === "email" && "Email Us"}
												</Box>
												<Box position={"absolute"} top={7} right={7}>
													<IconButton
														aria-label="close"
														color={"secondary"}
														onClick={handleClose}
													>
														<CloseIcon />
													</IconButton>
												</Box>
											</Box>
											<Divider light />
											<Box p={5}>
												<WebsiteWidgetForm value={value} />
											</Box>
										</div>
									</ClickAwayListener>
								</Paper>
							</Grow>
						)}
					</Popper>

					<Dialog
						scroll={"paper"}
						fullScreen={fullScreen}
						fullWidth={true}
						maxWidth={"sm"}
						open={open}
						TransitionComponent={Transition}
						keepMounted
						onClose={handleClose2}
						aria-labelledby="Add category"
						aria-describedby="Add category"
						classes={{
							paper: classes.dialogPaper,
							container: classes.dialogContainer,
						}}
						BackdropProps={{
							style: {
								backgroundColor: "rgba(182, 192, 205, 0.6)",
							},
						}}
					>
						<DialogTitle style={{ minHeight: 60 }}>
							<Box fontSize={22} fontWeight={600}>
								{value === "call" && "Call Me"}
								{value === "text" && "Text With Us"}
								{value === "email" && "Email Us"}
							</Box>
							<Box position={"absolute"} top={11} right={11}>
								<IconButton aria-label="close" onClick={handleClose2}>
									<CloseIcon />
								</IconButton>
							</Box>
						</DialogTitle>
						<DialogContent dividers>
							{value === "location" ? (
								<WebsiteLocationHours isDialog={true} />
							) : (
								<WebsiteWidgetForm value={value} />
							)}
						</DialogContent>
					</Dialog>
				</>
			)}
		</>
	);
};

WebsiteWidget.propTypes = {};
export default WebsiteWidget;
